<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11">
        <v-simple-table>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <!--タイトル-->
              <v-toolbar-title>
                お知らせ
                <v-icon medium class="mb-1" color="grey darken-1">
                  mdi-information
                </v-icon>
              </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
          </template>
          <!--お知らせテーブルのヘッダー-->
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">日付</th>
                <th class="text-left">内容</th>
              </tr>
            </thead>
            <!--お知らせテーブルの内容-->
            <tbody>
              <tr v-for="item in displayContents" :key="item.index">
                <td>
                  {{ item.date }}
                </td>
                <td>
                  <router-link :to="item.link">
                    {{ item.content }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!--ページネーション-->
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="changeLength()"
            :total-visible="5"
            @input="pageChange"
            circle
            color="teal darken-1"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          >
          </v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      // ページネーションに色がつく数字
      page: 1,
      // 5つ分のお知らせを表示
      pageSize: 5,
      // 表示させる分のお知らせの配列
      displayContents: [],
      // お知らせ
      contents: [
        {
          date: '2024/03/01',
          content:
            '物件情報ページにマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2024/02/14',
          content:
            '物件情報ページにマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2023/08/24',
          content:
            '物件情報ページにマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2022/07/12',
          content:
            '物件情報ページにマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2022/05/26',
          content:
            '物件情報ページにマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/12/28',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/11/05',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/09/03',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/07/14',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/06/24',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/06/04',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/04/20',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/03/23',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/02/18',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2021/01/27',
          content: '物件情報ページを更新しました。',
          link: '/Property'
        },
        {
          date: '2020/07/29',
          content: '物件情報ページに売りマンション情報を追加しました。',
          link: '/Property'
        },
        {
          date: '2020/03/11',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        },
        {
          date: '2020/04/20',
          content:
            '物件情報ページにライオンズマンション空室状況を追加しました。',
          link: '/Property'
        }
      ]
    }
  },
  methods: {
    // 表示させるお知らせを変更
    pageChange: function (pageNumber) {
      this.displayContents = this.contents.slice(
        this.pageSize * (pageNumber - 1),
        this.pageSize * pageNumber
      )
    },
    // 配列にお知らせが追加されたらページネーションの数を自動で増やす
    changeLength: function () {
      this.length = 1
      if (this.contents.length % 5 === 1) {
        this.length += 1
      }
      return this.length
    }
  },
  // 5つ分のお知らせを表示
  mounted: function () {
    this.displayContents = this.contents.slice(0, this.pageSize)
  }
}
</script>
